import React, { useState } from "react";
import { formatNumber } from "utils/currencyFormat";
import { ModalChiTiet } from "./ModalChiTiet";

export const BtnChiTietDaTra = ({ item }) => {
  console.log(item, "công nợ");
  const [show, setShow] = useState(false);

  const toggleModal = (id) => {
    if (id != null) {
      setThuChi(id);
    }

    setShow(!show);
  };

  const [ThuChi, setThuChi] = useState([]);
  return (
    <>
      {item.ListThuChiDaTra.map((item) => (
        <a href={() => false} onClick={(e) => toggleModal(item.ThuChiId)}>
          {formatNumber(item.SoTien)}
          <br />
        </a>
      ))}

      {show && (
        <ModalChiTiet
          show={show}
          onHide={(e) => toggleModal(null)}
          id={ThuChi}
        />
      )}

      {/* {show && (
        <ThanhToan
          show={show}
          onHide={handleClose}
          conNo={formatNumber(item.TienThanhLy + item.PhiKhac - item.TienDaTra)}
          ThanhLyId={item.ThanhLyID}
        />
      )} */}
    </>
  );
};
